module.exports = __webpack_public_path__ + "st.00894b0fff7d9729c5a4.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/st.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/st.svg
// module chunks = styles